import { isNoteEntry } from "@/features/notes/noteUtils";
import { type Opportunity, useHistory } from "@repo/api";
import { useSettings } from "@repo/ui";
import { addMinutes, isAfter } from "date-fns";

import {
  type HistoryEntryFilter,
  filterEntries,
  groupHistoryEntries,
  maskHistoryEntries,
} from "./utils";

export const useHistoryEntries = ({
  opportunity,
  filter,
  isShowAll,
}: {
  opportunity: Opportunity;
  filter: HistoryEntryFilter[];
  isShowAll: boolean;
}) => {
  const { data: historyEntries } = useHistory(opportunity.id);
  const { customerMode } = useSettings();

  const entries = historyEntries ?? [];

  const allEntries = groupHistoryEntries(
    customerMode ? maskHistoryEntries(entries) : entries
  ).filter((entry) => !isNoteEntry(entry));

  const now = new Date();
  const importantEntries = allEntries.filter(
    (e) => e.createdAt && isAfter(new Date(e.createdAt), addMinutes(now, -5))
  );

  let visibleActivities;

  if (isShowAll || filter.length > 0) {
    visibleActivities = allEntries.filter(filterEntries(filter));
  } else if (importantEntries.length > 0) {
    visibleActivities = importantEntries
      .filter(filterEntries(filter))
      .slice(0, 20);
  } else {
    visibleActivities = allEntries.filter(filterEntries(filter)).slice(0, 10);
  }

  return { visibleActivities, allEntries };
};
